import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { EMAIL_TEMPLATE_CONTROLLER } from "api/Service";

export const useCreateEmailTemplate = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (templateData) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}${EMAIL_TEMPLATE_CONTROLLER}`,
        templateData,
        { headers: { "Content-Type": "application/json" } }
      );

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["emailTemplatesAll"] });
    },
  });
};
